import { fetchCategoryBySlug, fetchCategories } from '../models/categoryModel.js';
import { fetchPostsByCategoryId } from '../models/postModel.js';

export const CategoryController = {
  postsBySlug: async (slug, options = {}) => {
    const categories = await fetchCategoryBySlug(slug);
    if (!categories.length) return { posts: [], totalPages: 0 };
    return fetchPostsByCategoryId(categories[0].id, options);
  },
  list: async () => fetchCategories(),
  list: async () => {
    const categories = await fetchCategories();
    return categories.filter(
      (cat) => !['uncategorized', 'sin-categoria'].includes(cat.slug)
    );
  },
};
